import { makeVar } from "@apollo/client";

export const isNewAppVersionAvailableVar = makeVar(false);
